import React, { useEffect, useState } from 'react';

import {
  Row,
  Col,
  Card,
  Form,
  Button,
  FloatingLabel,
  InputGroup,
} from 'react-bootstrap';

import { FaMapMarkerAlt } from 'react-icons/fa';
import ApiGServer from 'services/ApiGServer';
import SearchLocationInput from 'components/SearchLocationInput';
import { RENTAL_PLANS } from 'constants/planOptions';

const Forms = (props) => {
  const {
    equipments,
    fieldChange,
    onSubmit,
    permission,
    checkboxChange,
    checkboxIsentChange,
    handleAlertModalSuccess,
    handleAlertModalError,
    empresa,
    setLocationData,
    handlePlan
  } = props;

  const [link, setLink] = useState('')

  const [isValidLat, setIsValidLat] = useState(true);
  const [isValidLng, setIsValidLng] = useState(true);
  const [useMapPicker, setUseMapPicker] = useState(false);

  const handlePlanChange = (event) => {
    handlePlan(event.target.value)
  };

  useEffect(() => {
    if (empresa && empresa.typeCompany) {
      setLink(`/cooperatives/${empresa._id}`)
    } else {
      setLink(`/units/${empresa._id}`)
    }
  }, [empresa])

  const handleChange = (event) => {
    if (event.target.checked === true) {
      if (equipments.serialnumber.includes("SIMT")) {
        fieldChange(event, 'daystoactivate', 28)
        handleDaysChange(28)
      }
      if (equipments.serialnumber.includes("BIMT") || equipments.serialnumber.includes("CPMT")) {
        fieldChange(event, 'daystoactivate', 1)
        handleDaysChange(1)
      }
      if (equipments.serialnumber.includes("EEMT")) {
        fieldChange(event, 'daystoactivate', 5)
        handleDaysChange(5)
      }
    }
    checkboxChange(event.target.checked);
  };

  const handleDaysChange = async (data) => {
    try {
      await ApiGServer.post(`/equipment/updatedaysactivation`, {
        serialnumber: equipments.serialnumber,
        daystoactivate: data
          .toString(16)
          .toUpperCase()
      });
      handleAlertModalSuccess('Atualizado com Sucesso!');
    } catch (e) {
      handleAlertModalError('Falha ao atualizar!');
    }
  }

  const validateLatitude = (lat) => {
    const value = parseFloat(lat);
    return !isNaN(value) && value >= -90 && value <= 90;
  };

  const validateLongitude = (lng) => {
    const value = parseFloat(lng);
    return !isNaN(value) && value >= -180 && value <= 180;
  };

  const handleLatChange = (event) => {
    const value = event.target.value;
    const isValid = validateLatitude(value);
    setIsValidLat(isValid);
    fieldChange(event, 'lat', value);
  };

  const handleLngChange = (event) => {
    const value = event.target.value;
    const isValid = validateLongitude(value);
    setIsValidLng(isValid);
    fieldChange(event, 'lng', value);
  };

  return (
    <Card className='mb-3 mt-3'>

      <Card.Header>
        <h5 className='mt-2 mb-2'>Dados do Equipamento</h5>
      </Card.Header>
      <Card.Body>
        <Form>
          <Row className="g-2">
            <label className='mb-2'>Empresa:
              {empresa ?
                <a href={link} style={{ color: "green" }}>
                  {" "}{empresa.name}
                </a>
                : ' --'
              }
            </label>

            <Col md>
              <FloatingLabel controlId="floatingInput" label="Número de Série" className="mb-3">
                <Form.Control
                  type="text"
                  name="Número de Série"
                  placeholder="Número de Série"
                  value={equipments?.serialnumber || '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingInput" label="ID" className="mb-3">
                <Form.Control
                  type="text"
                  name="ID"
                  placeholder="ID"
                  value={equipments?.equipid || '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Nome do Equipamento" className="mb-3">
                <Form.Control
                  type="text"
                  name="Nome do Equipamento"
                  placeholder="Nome do Equipamento"
                  value={equipments?.nameEquipament || ''}
                  disabled
                />
              </FloatingLabel>
            </Col>
          </Row>

          {/* Seção de Calibração e Técnica */}
          <h6 className="text-muted mb-3 border-bottom pb-2">Informações Técnicas</h6>
          <Row className="g-2">
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Curva" className="mb-3">
                <Form.Control
                  type="text"
                  name="Curva"
                  placeholder="Curva"
                  value={equipments?.sha1curva || '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Data de Calibração" className="mb-3">
                <Form.Control
                  type="text"
                  name="Data de Calibração"
                  placeholder="Data de Calibração"
                  value={equipments?.dcal || '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingInput" label="ID do Copo" className="mb-3">
                <Form.Control
                  type="text"
                  name="ID do Copo"
                  placeholder="ID do Copo"
                  value={equipments?.cupid || '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
          </Row>

          <Row className="g-2">
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Curva Principal" className="mb-3">
                <Form.Control
                  type="text"
                  name="Curva Principal"
                  placeholder="Curva Principal"
                  value={equipments?.charts ? equipments?.charts?.principal : '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Curva Complementar" className="mb-3">
                <Form.Control
                  type="text"
                  name="Curva Complementar"
                  placeholder="Curva Complementar"
                  value={equipments?.charts ? equipments?.charts?.complementar : '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
          </Row>

          {/* Seção de Software e Hardware */}
          <h6 className="text-muted mb-3 border-bottom pb-2">Versões e Especificações</h6>
          <Row className="g-2">
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Versão do Software" className="mb-3">
                <Form.Control
                  type="text"
                  name="Versão do Software"
                  placeholder="Versão do Software"
                  value={equipments?.versaosw || '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Versão do Firmware Principal" className="mb-3">
                <Form.Control
                  type="text"
                  name="Versão do Firmware Principal"
                  placeholder="Versão do Firmware Principal"
                  value={equipments?.versaofwpri || '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Versão do Firmware Osciladora" className="mb-3">
                <Form.Control
                  type="text"
                  name="Versão do Firmware Osciladora"
                  placeholder="Versão do Firmware Osciladora"
                  value={equipments?.versaofwosc || '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
          </Row>

          <Row className="g-2">
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Tamanho do Copo" className="mb-3">
                <Form.Control
                  type="text"
                  name="Tamanho do Copo"
                  placeholder="Tamanho do Copo"
                  value={
                    Number(equipments.copo) === 0 ? "Sem dados" :
                      Number(equipments.copo) === 150 ? `Pequeno | ${Number(equipments.copo)}` :
                        Number(equipments.copo) > 150 ? `Pequeno | ${Number(equipments.copo)}` :
                          Number(equipments.copo) < 150 ? `Grande | ${Number(equipments.copo)}` : "--"}
                  disabled
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Versão do Termistor" className="mb-3">
                <Form.Control
                  type="text"
                  name="Versão do Termistor"
                  placeholder="Versão do Termistor"
                  value={
                    Number(equipments.copo) === 0 ? "Sem dados" :
                      Number(equipments.copo) === 150 ? "Rev 0" :
                        Number(equipments.copo) > 150 ? "Rev 1" :
                          Number(equipments.copo) < 150 ? "Rev 0" : "--"}
                  disabled
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Última Ativação por Email" className="mb-3">
                <Form.Control
                  type="text"
                  name="Última Ativação por Email"
                  placeholder="Última Ativação por Email"
                  value={equipments?.lastEmailActivation || '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
          </Row>

          <Row className="g-3 mb-3">
            <Col xs="auto">
              <Form.Check
                type="checkbox"
                label={`Full tracking ${equipments?.full_tracking ? '(ativo)' : '(inativo)'}`}
                checked={equipments?.full_tracking}
                onChange={(event) => fieldChange(event, 'full_tracking', event.target.checked)}
                disabled={!permission}
                isValid
              />
            </Col>
            <Col xs="auto">
              <Form.Check
                type="checkbox"
                label={`Foto facial ${equipments?.scan_face ? '(ativo)' : '(inativo)'}`}
                checked={equipments?.scan_face}
                onChange={(event) => fieldChange(event, 'scan_face', event.target.checked)}
                disabled={!permission}
                isValid
              />
            </Col>
            <Col xs="auto">
              <Form.Check
                type="checkbox"
                label={`Bandeja ${equipments?.tray ? '(ativo)' : '(inativo)'}`}
                checked={equipments?.tray}
                onChange={(event) => fieldChange(event, 'tray', event.target.checked)}
                disabled={!permission}
                isValid
              />
            </Col>
            <Col xs="auto">
              <Form.Check
                type="checkbox"
                label="Wifi"
                checked={equipments.wf === 'OK'}
                disabled
                isValid
              />
            </Col>
            <Col xs="auto">
              <Form.Check
                type="checkbox"
                label="PH Calibrado"
                checked={equipments.calph === 'OK'}
                disabled
                isValid
              />
            </Col>
            <Col xs="auto">
              <Form.Check
                type="checkbox"
                label="PH Calibrado"
                checked={equipments.calph === 'OK'}
                disabled
                isValid
              />
            </Col>
          </Row>

          {/* Localização Geográfica */}
          <h6 className="text-muted mb-3 border-bottom pb-2">
            <FaMapMarkerAlt className="me-2" />
            Localização Geográfica
          </h6>

          <Form.Check
            type="switch"
            id="map-picker-switch"
            label="Usar seletor de mapa"
            checked={useMapPicker}
            onChange={() => setUseMapPicker(!useMapPicker)}
            className="mb-3"
          />

          {useMapPicker ? (
            <div className="mb-3">
              <SearchLocationInput
                setLocation={(addr, lat, lng) =>
                  setLocationData({ address: addr, lat, lng })
                }
              />
            </div>
          ) : (
            <Row className="g-2">
              <Col md>
                <InputGroup className="mb-3">
                  <InputGroup.Text><FaMapMarkerAlt /></InputGroup.Text>
                  <FloatingLabel controlId="floatingLatitude" label="Latitude">
                    <Form.Control
                      type="text"
                      name="Latitude"
                      placeholder="Latitude"
                      value={equipments?.lat || ''}
                      onChange={handleLatChange}
                      isInvalid={!isValidLat && equipments?.lat}
                    />
                    <Form.Control.Feedback type="invalid">
                      Latitude inválida. Deve estar entre -90 e 90.
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </InputGroup>
              </Col>
              <Col md>
                <InputGroup className="mb-3">
                  <InputGroup.Text><FaMapMarkerAlt /></InputGroup.Text>
                  <FloatingLabel controlId="floatingLongitude" label="Longitude">
                    <Form.Control
                      type="text"
                      name="Longitude"
                      placeholder="Longitude"
                      value={equipments?.lng || ''}
                      onChange={handleLngChange}
                      isInvalid={!isValidLng && equipments?.lng}
                    />
                    <Form.Control.Feedback type="invalid">
                      Longitude inválida. Deve estar entre -180 e 180.
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </InputGroup>
              </Col>
            </Row>
          )}

          {/* Configurações e Ativação */}
          <h6 className="text-muted mb-3 border-bottom pb-2">Configurações de Ativação</h6>
          <Row className="g-2">
            <Col md>
              <FloatingLabel controlId="floatingInput" label="Dias para Ativação" className="mb-3">
                <Form.Control
                  type="text"
                  name="Dias para Ativação"
                  placeholder="Dias para Ativação"
                  value={equipments?.daystoactivate}
                  onChange={(event) => fieldChange(event, 'daystoactivate', event.target.value)}
                />
              </FloatingLabel>
            </Col>

            <Col md>
              <FloatingLabel controlId="floatingInput" label="Observação" className="mb-3">
                <Form.Control
                  type="text"
                  name="Observação"
                  placeholder="Observação"
                  value={equipments?.observation || ''}
                  onChange={(event) => fieldChange(event, 'observation', event.target.value)}
                />
              </FloatingLabel>
            </Col>

            {equipments?.serialnumber && (equipments?.serialnumber.includes("PRAR")) && (
              <Col md>
                <FloatingLabel controlId="floatingSelect" label="Tempo em segundos" className="mb-3">
                  <Form.Select
                    name="Tempo em segundos"
                    value={equipments?.config_temp}
                    onChange={(event) => fieldChange(event, 'config_temp', event.target.value)}
                  >
                    <option value="">Selecione o tempo</option>
                    {[
                      20, 30, 40, 50, 60,
                      120, 180, 240, 300,
                      360, 420, 480, 540, 600
                    ].map((seconds) => (
                      <option key={seconds} value={seconds}>
                        {seconds < 60
                          ? `${seconds} segundos`
                          : `${Math.floor(seconds / 60)} min ${seconds % 60 !== 0 ? seconds % 60 + ' s' : ''}`}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
            )}
          </Row>

          {/* Configurações de Modo e Plano */}
          <h6 className="text-muted mb-3 border-bottom pb-2">Modo de Operação e Plano</h6>
          <Row className="g-2">
            <Col xs="auto">
              <Form.Label>Modo: </Form.Label>
            </Col>
            <Col xs="auto">
              <Form.Check
                type="checkbox"
                label="LOCAÇÃO"
                checked={equipments?.mode === 'RENTAL'}
                onChange={handleChange}
                disabled={!permission}
                isValid
              />
            </Col>
            <Col xs="auto">
              <Form.Check
                type="checkbox"
                label="ISENÇÃO DE TAXAS"
                checked={equipments?.isentkey}
                onChange={(event) => checkboxIsentChange(event.target.checked)}
                disabled={!permission}
                isValid
              />
            </Col>
          </Row>
          <Row className="g-2">
            <Col xs="auto">
              <Form.Label>Plano: </Form.Label>
            </Col>
            <Col>
              <Form.Group>
                {equipments?.mode === "RENTAL" ? (
                  <>
                    {RENTAL_PLANS.map((plan) => (
                      <Form.Check
                        key={plan.value}
                        inline
                        type="radio"
                        label={plan.label}
                        value={plan.value}
                        name="plan"
                        checked={equipments?.plan === plan.value}
                        onChange={handlePlanChange}
                        disabled={!permission}
                        isValid
                      />
                    ))}
                  </>
                ) : (
                  <>
                    <Form.Check
                      inline
                      type="radio"
                      label="NORMAL"
                      value="NORMAL"
                      name="plan"
                      checked={equipments?.plan === "NORMAL"}
                      onChange={handlePlanChange}
                      disabled={!permission}
                      isValid
                    />
                    <Form.Check
                      inline
                      type="radio"
                      label="PLUS"
                      value="PLUS"
                      name="plan"
                      checked={equipments.plan === "PLUS"}
                      onChange={handlePlanChange}
                      disabled={!permission}
                      isValid
                    />
                    <Form.Check
                      inline
                      type="radio"
                      label="FLEX"
                      value="FLEX"
                      name="plan"
                      checked={equipments.plan === "FLEX"}
                      onChange={handlePlanChange}
                      disabled={!permission}
                      isValid
                    />
                    <Form.Check
                      inline
                      type="radio"
                      label="PREMIUM"
                      value="PREMIUM"
                      name="plan"
                      checked={equipments.plan === "PREMIUM"}
                      onChange={handlePlanChange}
                      disabled={!permission}
                      isValid
                    />
                  </>
                )}
              </Form.Group>
            </Col>
          </Row>


          {/* Botão de Salvar */}
          <Row className='g-2 mt-4'>
            <Col xs="auto">
              <Button
                style={{ width: 250 }}
                className='mb-3'
                disabled={!permission || (!isValidLat && equipments?.lat) || (!isValidLng && equipments?.lng)}
                onClick={() => onSubmit()}
                variant="success"
              >
                Salvar
              </Button>
            </Col>
          </Row>


        </Form>
      </Card.Body>
    </Card >
  );
};

export default Forms;
